module.exports = __webpack_public_path__ + "static/media/consumer_icon.fa096cf4.svg";